import React from 'react'
import PropTypes from 'prop-types'
import TextArea from '../../../form/component/TextArea'
import { formatDateTime } from '../../../../util/datetime'
import ContentBox from '../../../layout/component/ContentBox'
import currentUserHasAccess from '../../../../util/widget-helper'
import { COMMENT_LIST } from '../../../process/ui-definition/process-ui'
import Column from '../../../bootstrap/component/Column'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import Row from '../../../bootstrap/component/Row'

const textWithLink = (text) => {
    if (!text) {
        return null
    }
    const wordList = text.split(' ')
    return wordList.map((word, key) => {
        return word.startsWith('http') ? <a key={key} href={word} target="_blank" rel="noopener noreferrer">{word}&#160;</a> : word + ' '
    })
}


export const Comment = ({ comment }) => {
    if (!comment.message) {
        return null
    }

    const className = (comment.isUserAuthor) ? 'comment comment-sender' : 'comment comment-receiver'
    const author = (comment.isUserAuthor) ? '' : comment.author + ' '
    const iconClassName = (comment.isInternal) ? 'fa fa-lock fa-lg' : 'fa fa-globe fa-lg'

    return (
        <div key={comment.id} className="comment-container">
            <div className="comment-timestamp">
                <small>{author + formatDateTime(comment.created)}</small>
            </div>

            <div className="comment-icon">
                <i className={iconClassName}></i>
            </div>

            <div className={className}>
                {comment.message.split('\n').map((item, key) => {
                    return <span key={key}>{textWithLink(item)}<br/></span>
                })}
            </div>
        </div>
    )
}


const CommentList = ({ changeProcessComment, commentText, commentProcessInstance, commentList, validationMessageList }) => {
    if (!currentUserHasAccess(COMMENT_LIST)) {
        return null
    }
    return (
        <ContentBox title="Comment">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>
            {
                commentList && (
                    <div className="comment-list">
                        {commentList.map(comment => {
                            return <Comment
                                key={comment.id}
                                comment={comment}/>
                        })}
                    </div>
                )
            }
            <div className="comment-post">
                <TextArea className="form-control comment-post-textarea"
                    object={{
                        commentText,
                    }}
                    name="commentText"
                    onChange={changeProcessComment}
                    placeholder="Enter comment. Click button below to submit."/>
                <button
                    className="btn btn-primary"
                    disabled={!commentText}
                    onClick={commentProcessInstance}>
                    Save Comment
                </button>
            </div>

        </ContentBox>
    )
}

CommentList.propTypes = {
    changeProcessComment: PropTypes.func.isRequired,
    commentProcessInstance: PropTypes.func.isRequired,
    commentText: PropTypes.string,
    commentList: PropTypes.array,
}

export default CommentList



// WEBPACK FOOTER //
// ./src/modules/process/component/instance-detail/CommentList.js